import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建Vuex对象
const store = new Vuex.Store({
  state:{
    activeLabMb:-1,
    activeLabPc:-1,
  },
  mutations:{
    editActiveLabMb(state,newLab){
      state.activeLabMb = newLab
    },
    editActiveLabPc(state,newLab){
      state.activeLabPc = newLab
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js